import axios from '../../http';

const state = {
  token: null,
  interval: null
};

const getters = {
  token: state => state.token
};

const actions = {
  async getToken({ state, commit, dispatch }) {
    try {
      clearInterval(state.interval);

      const res = await axios({
        method: 'POST',
        baseURL: '/',
        url: 'auth/token'
      });
      commit('updateState', { prop: 'token', value: res.data });
      commit('updateState', { prop: 'interval', value: setInterval(() => dispatch('getToken'), 10000) });

      return res.data;
    } catch (error) {
      console.log(error);
      dispatch('page_loader/stop', null, { root: true });
      return null;
    }
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
